import appConstants from '@/constants/constants'

export default {
  // Document settings
  advisoryOpinionFieldsForHide: [
    { value: 'anamnesis', label: 'Анамнез' },
    { value: 'objective_examination_data', label: 'Данные объективного обследования' },
    { value: 'addition_to_diagnosis', label: 'Дополнение к диагнозу' },
    { value: 'mkb_diagnosis', label: 'Диагноз по МКБ-10' },
    { value: 'complaints', label: 'Жалобы' },
    { value: 'past_illnesses', label: 'Перенесенные заболевания' },
    { value: 'taking_medications', label: 'Прием лекарственных препаратов' },
    { value: 'recommendations', label: 'Рекомендации' },
  ],
  // Patient reception schedule settings
  patientReceptionScheduleSettings: [],
  // Price settings
  priceSettings: [],
  // Treatment diary settings
  treatmentDiarySettings: [],
  treatmentDiarySortTypeOptions: [
    {
      value: 'asc',
      text: 'От первого к последнему'
    },
    {
      value: 'desc',
      text: 'От последнего к первому'
    }
  ],
  // Employee settings
  employeeSettings: [],
  // Dental service settings
  dentalServiceSettings: [],
  // Patient card settings
  patientCardSettings: [],
  // Treatment presentation settings
  treatmentPresentationSettings: [],
  // Lead settings
  leadSettings: [],
  // Online appointment settings
  onlineAppointmentSettings: [],
  // Print formats
  printFormats: [
    {
      value: appConstants.setting.printFormat.APP_A4,
      text: appConstants.setting.printFormat.APP_A4,
    },
    {
      value: appConstants.setting.printFormat.APP_A5,
      text: appConstants.setting.printFormat.APP_A5,
    },
  ],
  // Warehouse settings
  warehouseSettings: [],
}
